export enum Languages {
    English = 0,
    Portuguese = 1,
    Spanish = 2,
    Mandarin = 3,
    French = 4,
    Italian = 5,
    Japanese = 6,
    Arabic = 7,
    German = 8,
    Russian = 9,
    Vietnamese = 10
};

export const listLanguages = [
    { value: Languages.English, label: 'English' },
    { value: Languages.Portuguese, label: 'Portuguese' },
    { value: Languages.Spanish, label: 'Spanish' },
    { value: Languages.Mandarin, label: 'Mandarin' },
    { value: Languages.French, label: 'French' },
    { value: Languages.Italian, label: 'Italian' },
    { value: Languages.Japanese, label: 'Japanese' },
    { value: Languages.Arabic, label: 'Arabic' },
    { value: Languages.German, label: 'German' },
    { value: Languages.Russian, label: 'Russian' },
    { value: Languages.Vietnamese, label: 'Vietnamese' }
];